import $http from "../axios";

const state = {
  transactions: []
};

const getters = {
  transactions: state => {
    return state.transactions;
  }
};

const actions = {
  getTransactions({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `transactions?storeId=${data.storeId}&beginDate=${data.dates[0]}&endDate=${data.dates[1]}`
        )
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_TRANSACTIONS", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_TRANSACTIONS(state, payload) {
    state.transactions = payload.transactions.sort((a, b) => {
      return new Date(a.createdAt) - new Date(b.createdAt);
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
